import { NumberInput } from '@mantine/core';
import { AddEditMatterFormData, Form } from '../types';
import styles from '../sharedStyles/InputField.module.css';
import { getInputPropsSafe, Paths } from '@/utils/getInputPropsSafe';
import NonIncrementingNumberInput from '@/components/NonIncrementingNumberInput';

const CurrencyInput = ({
  form,
  label,
  name,
  id,
}: {
  form: Form;
  label: string;
  name: Paths<AddEditMatterFormData>;
  id?: string;
}) => {
  return (
    <NonIncrementingNumberInput
      prefix='$'
      className={styles.inputField}
      {...getInputPropsSafe(form, name)}
      id={id ?? name}
      label={label}
      decimalScale={2}
      min={0.0}
    />
  );
};

export default CurrencyInput;
